<template>
  <form>
    <vnt-input v-model="category.name" type="text" label="Name" />
    <footer>
      <vnt-button :click="handleCancel">Cancel</vnt-button>
      <vnt-button v-if="categoryId" :click="handleRemove">Remove</vnt-button>
      <vnt-button primary :click="handleSave">Save</vnt-button>
    </footer>
  </form>
</template>

<script>
import { create } from '@mizz/penny-core/entities/category'
import { save, remove, getById } from '@/services/categories'

export default {
  name: 'CategoryForm',

  props: ['categoryId'],

  data() {
    return {
      category: create()
    }
  },

  methods: {
    handleCancel() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },

    async handleSave() {
      await save(this.category)
      this.$router.go(-1)
    },

    async handleRemove() {
      await remove(this.category)
      this.$router.go(-1)
    }
  },

  mounted() {
    if (this.categoryId) {
      getById(this.categoryId).then(category => this.category = category)
    }
  }
}
</script>

<style scoped>
footer {
  margin: 24px 0;
}
</style>
